<ng-container *ngIf="isAuth$ | async; else loginView">
	<a
		*ngIf="isBonusButtonEnabled$ | async"
		mat-mini-fab
		test-id="header-promotion-button"
		[obgInteraction]="bonusTrackingData"
		[obgRouteLink]="activeRewardsRoute"
		[obgRouteLinkOptions]="{ queryParams: { skipTabOnEmpty: 'true' } }"
		matTooltip="{{'secondary-menu.common.bonuses' | translate}}"
		matTooltipClass="obg-m-navigation-tooltip"
	>
		<span class="ico-promotions"></span>
	</a>

	<obg-app-m-oms-summary-container></obg-app-m-oms-summary-container>
	<obg-m-user-summary-container [showRunningBalanceMsg]="hideWithdrawButton"></obg-m-user-summary-container>
	<a
		*ngIf="withdrawButtonEnabled && !hideWithdrawButton"
		[obgRouteLink]="withdrawRoute"
		[obgInteraction]="withdrawTrackingData"
		[ngClass]="{ 'header-withdraw-button': isAlternativeButtonStyleEnabled, 'header-gaming-withdraw-button': gamingLayout }"
		mat-stroked-button
		color="basic"
		test-id="header-withdraw-button"
		data-test-id="header-withdraw-button"
		>{{ 'general.withdraw' | translate }}</a
	>
	<a
		*ngIf="!depositButtonHidden"
		[obgRouteLink]="depositRoute"
		[obgInteraction]="depositTrackingData"
		[ngClass]="{ 'header-deposit-button': isAlternativeButtonStyleEnabled }"
		mat-flat-button
		color="accent"
		test-id="header-deposit-button"
		data-test-id="header-deposit-button"
		>{{ 'general.deposit' | translate }}</a
	>
</ng-container>

<ng-template #loginView>
	<ng-container *ngIf="alternativeLoginForm else commonLogin">
		<obg-lazy-loader [lazyItem]="alternativeLoginForm"> </obg-lazy-loader>
	</ng-container>
	<ng-template #commonLogin>
		<a
			color="primary"
			mat-flat-button
			class="login"
			[obgRouteLink]="loginRoute"
			[obgInteraction]="loginTrackingData"
			[ngClass]="{ 'alternative': isAlternativeButtonStyleEnabled }"
			test-id="header-login-button"
			data-test-id="header-login-button"
		>
			<mat-spinner *ngIf="isAuthenticating$ | async else loginButtonText" diameter="20"></mat-spinner>
			<ng-template #loginButtonText>{{ "user-summary.login" | translate }}</ng-template>
		</a>
		<a
			*ngIf="isRegisterButtonVisible && jurisdiction$ | async as jurisdiction"
			mat-flat-button
			color="accent"
			[obgRouteLink]="registerRoute"
			[obgInteraction]="openAccountTrackingData"
			[ngClass]="{ 'open-account': isAlternativeButtonStyleEnabled }"
			test-id="header-open-account-button"
			data-test-id="header-open-account-button"
			>{{ "user-summary.create-account" | translate }}</a
		>
	</ng-template>
</ng-template>
